import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Popup } from '@progress/kendo-react-popup';
import { ExpandMore } from 'styled-icons/material';
import { User } from 'styled-icons/boxicons-solid';
import { Profile } from 'styled-icons/remix-fill';
import { LogOut, EditAlt } from 'styled-icons/boxicons-regular';
import styled from 'styled-components';
import PageEditor from './editor';
import Footer from './footer';

const imageFirstSection =
  'https://firebasestorage.googleapis.com/v0/b/pieza-development.appspot.com/o/ramdom%2Fmichael-afonso-b632f-baARE-unsplash-1.png?alt=media&token=6b601590-85e5-41b7-951a-87df417e616c';
const imageSecondSection =
  'https://firebasestorage.googleapis.com/v0/b/pieza-development.appspot.com/o/ramdom%2Ffabio-lucas-FfhAbND-lxk-unsplash-1.png?alt=media&token=f87eb65d-2982-4fee-be3d-dcecc8f92a3e';

export default function VisualSettings() {
  const anchor = React.useRef();
  const blurTimeoutRef = React.useRef();
  const contentRef = React.useRef();

  const platform = useSelector((state) => state.platform);
  const [state, setState] = useState({
    ShowEditor: false,
    show: false,
  });
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const onBlurTimeout = () => {
    // the user is now outside the popup
    setState((prev) => ({ ...prev, show: false }));
  };

  const onOpen = () => {
    contentRef.current.focus();
  };

  const onFocus = () => {
    // the user is still inside the content
    clearTimeout(blurTimeoutRef.current);
  };

  const onBlur = () => {
    clearTimeout(blurTimeoutRef.current);
    blurTimeoutRef.current = setTimeout(onBlurTimeout, 200);
  };

  const handleEditor = async () => {
    await setState((prevState) => ({ ...prevState, ShowEditor: false }));
  };

  return (
    <div className="visualSettingsContainer">
      <div className="previewContainer">
        <nav className="navBarPreview">
          <div className="navBarLogoContainer" style={{ backgroundImage: `url(${platform.platformLogo})` }} />
          <div className="leftMenu">
            <div className="leftMenu">
              <p className="leftMenuLink">Vacantes</p>
            </div>
          </div>
          <div className="rightMenu">
            <button
              type="button"
              className="ant-dropdown-link"
              onClick={(e) => e.preventDefault()}
              style={{ color: platform?.primaryColor || '', margin: 'auto 40px' }}>
              <User color={platform?.primaryColor || ''} size={20} /> Mi cuenta{' '}
              <ExpandMore color={platform?.primaryColor || ''} size={20} />
            </button>
            <Popup anchor={anchor.current} show={state.show} onOpen={onOpen} popupClass="popup-content">
              <div ref={contentRef} tabIndex={0} onFocus={onFocus} onBlur={onBlur}>
                <div style={{ display: 'flex' }}>
                  <Profile size={20} />
                  <button type="button">Mi perfil</button>
                </div>
                <div style={{ display: 'flex' }}>
                  <LogOut size={20} />
                  <button type="button">Cerrar sesión</button>
                </div>
              </div>
            </Popup>
            <p
              className="ant-dropdown-link"
              style={{ color: platform?.primaryColor || '', cursor: 'pointer', margin: 0 }}>
              Iniciar sesión
            </p>
          </div>
        </nav>
        <StyledPreview />
        <Footer />
      </div>
      <div className="editorArea">
        <div className="editionButtonContainer">
          <div className="editButton" onClick={() => setState((prevState) => ({ ...prevState, ShowEditor: true }))}>
            <EditAlt size={20} />
            <label className="editText">Editar</label>
          </div>
        </div>
      </div>
      {state.ShowEditor ? <PageEditor handleEditor={handleEditor} /> : null}
    </div>
  );
}

const Home = (props) => {
  const platform = useSelector((state) => state.platform);

  return (
    <main className={props.className}>
      <div className="home-container">
        {platform.interfaceSelected === 1 ? (
          <section className="home-hero">
            <article>
              <h1 className="home__title home__title--dark">{platform.mainTitle}</h1>
              <p className="home__description home__description--dark">{platform.mainSubText}</p>
              <a>Login</a>
            </article>
            <img
              className={platform.customImageURL === '' ? 'home__background--circle' : 'home__background--custom'}
              src={
                platform.customImageURL === ''
                  ? 'https://firebasestorage.googleapis.com/v0/b/lapieza-production.appspot.com/o/imgDefault%2Fhero-image-bg.png?alt=media&token=3e9aff77-7b55-4bc8-85c8-48b0bebfceab'
                  : platform.customImageURL
              }
            />
          </section>
        ) : (
          <section
            className="home__interface__large"
            style={{
              background: `url(${
                platform.customImageURL === ''
                  ? 'https://firebasestorage.googleapis.com/v0/b/lapieza-production.appspot.com/o/imgDefault%2Fhero-image-bg.png?alt=media&token=3e9aff77-7b55-4bc8-85c8-48b0bebfceab'
                  : platform.customImageURL
              }) center/cover`,
            }}>
            <article>
              <div>
                <h1 className="home__title-circle">{platform.mainTitle}</h1>
                <p className="home__description-circle">{platform.mainSubText}</p>
              </div>
              <a>Login</a>
            </article>
          </section>
        )}
        <section className="first-secction">
          <article>
            <h3 className="home__subtitle">{platform.studentTitle}</h3>
            <div>
              <p>{platform.studentText}</p>
              <a>Signup</a>
            </div>
          </article>
          <img
            className="image-right"
            src={platform.customThirdImage !== '' ? platform.customThirdImage : imageFirstSection}
            alt="| LaPieza.io"
          />
        </section>
        <section className="first-secction first-secction-column-reverse">
          <img
            className="image-left"
            src={platform.customSecondImageLink !== '' ? platform.customSecondImageLink : imageSecondSection}
            alt="| LaPieza.io"
          />
          <article>
            <h3 className="home__subtitle">{platform.companyTitle}</h3>
            <div>
              <p>{platform.companyText}</p>
              <a onClick={() => props.history.push('/registro-empresa')}>Signup</a>
            </div>
          </article>
        </section>
        <section className="brands-section">
          <img
            src={
              platform.platformCustomLogo1
                ? platform.platformCustomLogo1
                : 'https://firebasestorage.googleapis.com/v0/b/lapieza-production.appspot.com/o/imgDefault%2Faxa.svg?alt=media&token=5a796ff8-8224-49b5-a5b3-a8f2574c18f7'
            }
            alt="LaPieza.io Partners"
          />
          <img
            src={
              platform.platformCustomLogo2
                ? platform.platformCustomLogo2
                : 'https://firebasestorage.googleapis.com/v0/b/lapieza-production.appspot.com/o/imgDefault%2Fmoons.svg?alt=media&token=209ecb8e-0e40-4b65-a006-a2d5aa73ca48'
            }
            alt="LaPieza.io Partners"
          />
          <img
            src={
              platform.platformCustomLogo3
                ? platform.platformCustomLogo3
                : 'https://firebasestorage.googleapis.com/v0/b/lapieza-production.appspot.com/o/imgDefault%2Fconekta.png?alt=media&token=41812e5c-bc86-4279-b939-fc6cc19e19c5'
            }
            alt="LaPieza.io Partners"
          />
          <img
            src={
              platform.platformCustomLogo4
                ? platform.platformCustomLogo4
                : 'https://firebasestorage.googleapis.com/v0/b/lapieza-production.appspot.com/o/imgDefault%2Fmercado.png?alt=media&token=90069f53-2c4d-42fd-a7bb-d3dbd8ace132'
            }
            alt="LaPieza.io Partners"
          />
          <img
            src={
              platform.platformCustomLogo5
                ? platform.platformCustomLogo5
                : 'https://firebasestorage.googleapis.com/v0/b/lapieza-production.appspot.com/o/imgDefault%2Fjusto.png?alt=media&token=7ad86670-48ed-4123-ab20-cff47fe0cb5e'
            }
            alt="LaPieza.io Partners"
          />
        </section>
      </div>
      <img
        className="circle-decoration-right"
        src="https://firebasestorage.googleapis.com/v0/b/lapieza-production.appspot.com/o/imgDefault%2Fcircle-decoration.png?alt=media&token=b1d3dc6f-3c17-46a6-bee8-14387ad44a7e"
        alt="Universidades| LaPieza.io"
      />
      <img
        className="circle-decoration-left"
        src="https://firebasestorage.googleapis.com/v0/b/lapieza-production.appspot.com/o/imgDefault%2Fcircle-decoration.png?alt=media&token=b1d3dc6f-3c17-46a6-bee8-14387ad44a7e"
        alt="Universidades| LaPieza.io"
      />
    </main>
  );
};

const StyledPreview = styled(Home)`
  padding: 0px 7.81%;
  background-color: #f8f8f8;
  position: relative;
  overflow: hidden;
  font-size: 10px;
  .home-container {
    max-width: 1631px;
    margin: 0px auto;
    font-size: inherit !important;
  }
  .icon-arror-right {
    color: #acacac;
  }
  .home__subtitle {
    font-size: 2.8em;
    font-weight: 500;
    line-height: 2.5em;
    color: #acacac;
    margin-bottom: 1.875em;
  }
  .home__interface__large {
    width: 100%;
    margin: 10px auto;
    display: -ms-flexbox;
    display: flex;
    height: 100%;
    min-height: 55vh;
    justify-content: flex-start;
    align-items: center;
    article {
      background-color: white;
      display: flex;
      left: -40px;
      position: relative;
      border-radius: 50%;
      width: 390px;
      height: 390px;
    }
    div {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    a {
      position: absolute;
      width: 100px;
      height: 100px;
      right: -60px;
      background-color: var(--button-color);
      top: calc(50% - 60px);
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      color: white;
      font-size: 2rem;
    }
  }
  .home__title-circle {
    font-size: 2.8rem;
    line-height: 1.41em;
    font-weight: 700;
    margin-bottom: 0.59em;
    margin-top: 0.618em;
    text-align: left;
    width: 80%;
  }
  .home__description-circle {
    width: 80%;
    font-size: 1.6rem;
    text-align: left;
    margin: 10px auto;
  }
  .home__title {
    font-size: 3.8em;
    line-height: 1.41em;
    font-weight: 500;
    margin: 20px auto;
    text-align: right;
    &--dinamyc {
      color: #00ae8c;
    }
    &--dark {
      color: #191919;
    }
    @media (max-width: 768px) {
      text-align: center;
    }
  }
  .home-hero {
    display: grid;
    grid-template-columns: 50% 50%;
    padding: 9em 0px 6.7em 0px;
    @media (max-width: 768px) {
      grid-template-columns: 1fr;
      justify-items: center;
      padding: 0px;
    }
    article {
      margin-right: 10.8em;
      display: flex;
      flex-direction: column;
      @media (max-width: 768px) {
        margin: 0px;
        z-index: 1;
      }
      .home__description {
        font-size: 2.2em;
        font-weight: 350;
        line-height: 1.25em;
        text-align: right;
        max-width: 18.28125em;
        align-self: flex-end;
        margin: 0px;
        &--dinamyc {
          color: #00aebc;
        }
        &--dark {
          color: #191919;
        }
        @media (max-width: 768px) {
          text-align: center;
          margin: 0px auto 5.7rem auto;
        }
      }
      a {
        font-size: 2.8em;
        line-height: 1.25em;
        font-weight: 500;
        color: var(--button-color);
        height: 2em;
        width: 8.375em;
        align-self: flex-end;
        display: flex;
        justify-content: center;
        align-items: center;
        border: solid 1px var(--button-color);
        margin-top: 2.375em;
        @media (max-width: 768px) {
          align-self: center;
        }
      }
      a:hover {
        color: white;
        background-color: var(--button-color);
      }
    }
    figure {
      @media (max-width: 768px) {
        font-size: 10px;
      }
      max-height: 88.8em;
      height: 100%;
      width: 100%;
      position: relative;
      @media (max-width: 768px) {
        max-width: 39.4em;
      }
      img {
        width: inherit;
        height: inherit;
        object-fit: cover;
      }
      div {
        position: absolute;
        background: rgba(25, 25, 25, 0.2);
        height: inherit;
        width: inherit;
        top: 0;
        display: grid;
        justify-content: flex-end;
        align-items: end;
        button {
          height: 50px;
          width: 50px;
          outline: none;
          border-radius: 0px;
          padding: 0px;
          color: #e9e9e9;
          background-color: #ffffff;
          &:hover {
            color: #5fc08e;
          }
        }
      }
    }
    .home__background--circle {
      background-size: cover;
      width: 80em;
      height: 80em;
      border-radius: 50%;
      position: absolute;
      right: -11.5em;
      object-fit: cover;
    }
    .home__background--custom {
      background-size: cover;
      width: 50em;
      height: auto;
      position: absolute;
      right: 5.5em;
      object-fit: cover;
    }
  }
  .first-secction {
    display: grid;
    grid-template-columns: 1fr 1fr;
    margin-top: 16.8em;
    grid-gap: 0px 70px;
    @media (max-width: 940px) {
      grid-gap: 140px;
      grid-template-columns: 1fr;
      justify-items: center;
    }
    img {
      width: 100%;
      max-width: 62.8em;
      max-height: 78.9em;
      object-fit: cover;
    }
    .image-left {
      justify-self: flex-start;
      @media (max-width: 940px) {
        justify-self: center;
      }
    }
    .image-right {
      justify-self: flex-end;
      @media (max-width: 940px) {
        justify-self: center;
      }
    }
    article {
      padding-top: 2em;
      @media (max-width: 940px) {
        padding: 0;
      }
      div {
        position: relative;
        font-size: inherit !important;
      }
      p {
        font-size: 2rem;
        line-height: 1.40625em;
        font-weight: 500;
        color: #191919;
        max-width: 19.40625em;
        width: 100%;
        margin-left: 0em;
        position: relative;
        z-index: 1;
        @media (max-width: 940px) {
          max-width: 621px;
        }
      }
      a {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 2em;
        height: 6em;
        width: 6em;
        border-radius: 50%;
        background-color: var(--button-color);
        font-weight: 500;
        line-height: 1.6666666666666667em;
        color: #ffffff;
        position: absolute;
        right: -1em;
        top: 62%;
        @media (max-width: 940px) {
          top: 90%;
        }
      }
    }
    &-column-reverse {
      @media (max-width: 940px) {
        display: flex;
        flex-direction: column-reverse;
        align-items: center;
      }
    }
  }
  .brands-section {
    padding: 44em 0px;
    display: grid;
    grid-template-columns: repeat(auto-fill, 300px);
    justify-items: center;
    grid-gap: 80px 40px;
    justify-content: space-evenly;
    img {
      width: 100%;
      min-width: 170px;
      max-width: 200px;
      filter: grayscale(1);
      opacity: 0.3;
    }
    img:hover {
      filter: grayscale(0);
      opacity: 1;
    }
  }
  .galery-section {
    max-width: 120em;
    margin: 0px auto 64px auto;
    &-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: inherit !important;
      margin-bottom: 8.8em;
      a {
        padding: 16px;
      }
      .home__subtitle {
        margin: 0px;
      }
    }
    &-list {
      display: grid;
      //grid-template: ;
      grid-template-columns: 1fr 1fr 1fr 1fr;
      grid-gap: 45px;
      @media (max-width: 940px) {
        grid-template-columns: 1fr 1fr;
      }
      font-size: inherit !important;
      @media (max-width: 1024px) {
        font-size: 7.5px !important;
      }
      article {
        img {
          width: 100%;
          object-fit: cover;
        }
        h5 {
          color: #191919;
          font-size: 2.4em;
          line-height: 1.3333333333333333em;
          font-weight: 500;
          margin: 16px 0px;
        }
        p {
          font-size: 1.6em;
          line-height: 2.4em;
          font-weight: 400;
          color: #acacac;
        }
      }
      article:nth-child(1) img {
        height: 200px;
      }
      article:nth-child(2) img {
        height: 294px;
      }
      article:nth-child(3) img {
        height: 388px;
      }
      article:nth-child(4) img {
        height: 135px;
      }
    }
  }
  .circle-decoration-right {
    @media (max-width: 940px) {
      font-size: 2px;
    }
    width: 80em;
    height: 80em;
    position: absolute;
    bottom: -37.9em;
    right: -34.5em;
    z-index: 0;
  }
  .circle-decoration-left {
    @media (max-width: 940px) {
      font-size: 2px;
    }
    width: 68em;
    height: 68em;
    position: absolute;
    bottom: -37.9em;
    left: -24.2em;
    z-index: 0;
  }
  @media (max-width: 1632px) {
    font-size: 8.5px;
  }
  @media (max-width: 1440px) {
    font-size: 7.5px;
  }
  @media (max-width: 1024px) {
    font-size: 5.33333333px;
  }
  @media (max-width: 768px) {
    font-size: 6.25px;
  }
`;
